<div *ngIf="autocompleteService._state() !== 'hide'" class="w-full relative">
    <header *ngIf="autocompleteService._isMobile()">
        <div (click)="autocompleteService.setState('hide')" class="flex items-center gap-4 px-4 py-2 pb-0">
            <i class="ico-ArrowRight text-2xl"></i>
            <p class="text-lg">
                {{searchBoxService.accommodation() == 'ecolodge' ? 'نام شهر یا کد آگهی' : 'مقصد یا هتل'}}
            </p>
        </div>
    </header>
    <div class="sm:hidden w-full h-[2px] my-2 bg-gray-200"></div>
    <div *ngIf="autocompleteService._isMobile()" class="mt-4 px-4">
        <div ihoAutocomplete>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>
                    {{searchBoxService.accommodation() == 'ecolodge' ? 'نام شهر یا کد آگهی' : 'مقصد یا هتل'}}
                </mat-label>
                <input matInput class="!font-bold" id="autocompleteinput" #autocompleteinput
                autocomplete="off" name="dontrememberthis"
                    [value]="autocompleteService._selectedItem().name !== undefined ? autocompleteService._selectedItem().name : ''">
                <mat-icon matPrefix>
                    <i class="mr-2 ico-Location text-xl text-gray-500"></i>
                </mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div [ngSwitch]="autocompleteService._state()" class="w-[100%] sm:absolute sm:top-[calc(100%+8px)] right-0 sm:z-50">
        <div
            class="autocomplete-layout p-4 bg-white border-none md:border-2 md:border-solid md:border-gray-200 rounded-2xl">

            <!-- loading -->
            <ng-container *ngSwitchCase="'loading'">
                <div class="iho-autocomplete loading">
                    <div class="flex flex-col gap-8">
                        <div class="flex justify-between gap-16">
                            <div class="w-10 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                            <div class="flex flex-col gap-2 w-36">
                                <div class="w-full h-4 bg-slate-200 rounded-lg animate-pulse"></div>
                                <div class="w-full h-2 bg-slate-200 rounded-lg animate-pulse"></div>
                            </div>
                            <div class="w-36 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                        </div>
                        <div class="flex justify-between gap-16">
                            <div class="w-10 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                            <div class="flex flex-col gap-2 w-36">
                                <div class="w-full h-4 bg-slate-200 rounded-lg animate-pulse"></div>
                                <div class="w-full h-2 bg-slate-200 rounded-lg animate-pulse"></div>
                            </div>
                            <div class="w-36 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                        </div>
                        <div class="flex justify-between gap-16">
                            <div class="w-10 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                            <div class="flex flex-col gap-2 w-36">
                                <div class="w-full h-4 bg-slate-200 rounded-lg animate-pulse"></div>
                                <div class="w-full h-2 bg-slate-200 rounded-lg animate-pulse"></div>
                            </div>
                            <div class="w-36 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                        </div>
                        <div class="flex justify-between gap-16">
                            <div class="w-10 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                            <div class="flex flex-col gap-2 w-36">
                                <div class="w-full h-4 bg-slate-200 rounded-lg animate-pulse"></div>
                                <div class="w-full h-2 bg-slate-200 rounded-lg animate-pulse"></div>
                            </div>
                            <div class="w-36 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                        </div>
                        <div class="flex justify-between gap-16">
                            <div class="w-10 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                            <div class="flex flex-col gap-2 w-36">
                                <div class="w-full h-4 bg-slate-200 rounded-lg animate-pulse"></div>
                                <div class="w-full h-2 bg-slate-200 rounded-lg animate-pulse"></div>
                            </div>
                            <div class="w-36 h-8 bg-slate-200 rounded-lg animate-pulse"></div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- loading -->

            <!-- nothing -->
            <ng-container *ngSwitchCase="'nothing'">
                <div class="iho-autocomplete nothing">
                    <p class="block text-center font-bold">
                        موردی یافت نشد.
                    </p>
                </div>
            </ng-container>
            <!-- nothing-ecolodge -->
            <ng-container *ngSwitchCase="'nothing-ecolodge'">
                <div class="iho-autocomplete nothing">
                    <p class="block text-center font-bold cursor-pointer" (click)="searchNothing()">
                    با کلیک عبارت “{{autocompleteService._result()}}” را در سایت جستجو کنید
                      <i class="mr-2 ico-ArrowLeft text-xl font-bold float-left"></i>
                    </p>
                </div>
            </ng-container>
            <!-- nothing -->

            <!-- result -->
            <ng-container *ngSwitchCase="'result'">
                <div class="iho-autocomplete result max-h-[60vh] overflow-y-auto">
                    <div class="flex flex-col gap-6">
                        <ng-container *ngFor="let parentItem of autocompleteService._result()">
                            <ng-container *ngIf="shouldShow(parentItem)">
                                <div (click)="setSelectedItem(parentItem)" id="set-selected-item-parentitem"
                                    class="flex items-center justify-between p-2 ml-2 cursor-pointer hover:bg-slate-50 hover:rounded-lg hover:transition">
                                    <div class="flex items-center justify-between gap-2">
                                  
                                        <!-- <p *ngIf="parentItem.type === 2 " class="block font-bold">
                                            <span class="ico-Location text-xl"></span>
                                            {{parentItem.name}}
                                        </p> -->
                                        <ng-container
                                            *ngIf="parentItem.type  === 1 || parentItem.type === 5 || parentItem.type == 6 || parentItem.type === 2">
                                            <span class="ico-Location text-xl"></span>
                                        </ng-container>
                                        <ng-container *ngIf="parentItem.type  === 3">
                                            <span class="ico-Building text-xl"></span>
                                        </ng-container>
                                        <div class="flex flex-col">
                                            <p *ngIf="parentItem.type === 1 || parentItem.type === 5 || parentItem.type == 6 || parentItem.type === 2"
                                                class="block font-bold">
                                                {{parentItem.name}}
                                            </p>
                                            <p *ngIf="parentItem.type === 3" class="block font-bold">
                                                {{parentItem.name}}
                                            </p>
                                            <small
                                                *ngIf="parentItem.type === 1 || parentItem.type === 5 || parentItem.type == 6 || parentItem.type === 2"
                                                class="block font-bold">
                                                {{parentItem.state}}
                                                {{parentItem.state != "عراق" ? '،' : '' }}
                                                {{parentItem.state != "عراق" ? parentItem.country : ''}}
                                            </small>
                                            <small *ngIf="parentItem.type === 3" class="block font-bold">
                                                {{parentItem.state}}،
                                                {{parentItem.country}}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="text-left">
                                        <small
                                            *ngIf="parentItem.type === 1 || parentItem.type === 5 || parentItem.type == 6 || parentItem.type === 2">
                                            {{parentItem.count}} واحد اقامتی
                                        </small>
                                        <div *ngIf="parentItem.type === 3">
                                            <ng-container *ngFor="let childItem of [].constructor(parentItem.grade)">
                                                <span class="ico-Star-bold text-amber-400"></span>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                         
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <!-- result -->

            <!-- favorite -->
            <ng-container *ngSwitchCase="'favorite'">
                <div class="iho-autocomplete favorite">
                    <small class="inline-block w-auto font-bold mb-4 p-2 rounded-lg text-slate-600 bg-slate-100">
                        شهرهای پرطرفدار
                    </small>
                    <div class="flex justify-between gap-2">
                        <div *ngFor="let item of autocompleteService._favorite()">
                            <div (click)="setSelectedItem(item)" id="set-selected-item-favorite"
                                class="w-full h-12 mb-2 bg-slate-200 rounded-lg overflow-hidden cursor-pointer">
                                <img class="w-full h-full aspect-square object-cover" src={{item.image}} />
                            </div>
                            <small (click)="setSelectedItem(item)" id="set-selected-item-favorite"
                                class="block text-center font-bold">
                                {{item.name}}
                            </small>
                        </div>
                    </div>
                </div>
                <div *ngIf="autocompleteService._recent().length !== 0" class="w-full h-[1px] my-4 bg-slate-200">
                </div>
                <div *ngIf="autocompleteService._recent()" class="recent">
                    <small class="inline-block w-auto mb-4 p-2 rounded-lg text-slate-600 bg-slate-100">
                        جستجوهای اخیر
                    </small>
                    <div class="flex flex-col gap-6">
                        <div *ngFor="let item of autocompleteService._recent()" id="set-selected-item-recent"
                            (click)="setRecentItem(item)">
                            <div
                                class="flex items-center justify-between p-2 cursor-pointer hover:bg-slate-50 hover:rounded-lg hover:transition">
                                <div class="flex items-center justify-between gap-2">
                                    <ng-container *ngIf="item.type  === 1">
                                        <span class="ico-Location text-xl text-slate-400"></span>
                                    </ng-container>
                                    <ng-container *ngIf="item.type  === 2">
                                        <span class="ico-Building text-xl text-slate-400"></span>
                                    </ng-container>
                                    <div class="flex flex-col">
                                        <p class="block font-bold">
                                            {{item.name}}
                                        </p>
                                        <small class="block text-slate-400">
                                            {{item.city}}
                                            {{item.state}}
                                        </small>
                                    </div>
                                </div>
                                <div class="text-left">
                                    <small class="block">
                                        از
                                        {{item.date}}
                                        تا
                                        {{item.endDate}}
                                    </small>
                                    <small class="block">
                                        {{item.adultNumber ?? 1}}
                                        بزرگسال،
                                        {{item.childNumber ?? 0}}
                                        خردسال
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</div>